module.exports = __webpack_public_path__ + "static/evce-power-09f6bf76ac53a47a0417245b7208d77f.png";